import type { ChatMessage } from 'src/shared/components/SaraChat/types/chatMessage'

const parseMessageContent = (content: ChatMessage['content']) => {
  if (typeof content === 'string') {
    try {
      return JSON.parse(content || '{}') as Record<string, unknown>
    } catch {
      return {}
    }
  }
  return (content ?? {}) as Record<string, unknown>
}

export const isPrivateSaraUserContent = (
  content: ChatMessage['content']
): boolean => {
  return parseMessageContent(content).private === true
}

export const isAdminSaraContent = (content: ChatMessage['content']): boolean => {
  return parseMessageContent(content).admin === true
}

export type AnnotatedSaraMessage = {
  message: ChatMessage
  isPrivate: boolean
  isAdmin: boolean
}

/**
 * A Sara turn is private when the latest preceding user message was marked
 * private (`sara_…`). It is admin-only when the user message (or a persisted
 * reply) is tagged `admin: true`. Following assistant/system/status inherit both.
 */
export const withSaraMessagePrivacy = (
  messages: ChatMessage[]
): AnnotatedSaraMessage[] => {
  const sorted = [...messages].sort(
    (a, b) =>
      new Date(a.created_at ?? 0).getTime() -
      new Date(b.created_at ?? 0).getTime()
  )

  let inPrivateTurn = false
  let inAdminTurn = false

  return sorted.map((message) => {
    const taggedAdmin = isAdminSaraContent(message.content)

    if (message.role === 'user') {
      inPrivateTurn = isPrivateSaraUserContent(message.content)
      inAdminTurn = taggedAdmin
      return { message, isPrivate: inPrivateTurn, isAdmin: inAdminTurn }
    }

    if (taggedAdmin) inAdminTurn = true
    return { message, isPrivate: inPrivateTurn, isAdmin: inAdminTurn }
  })
}
